export default {
  en: {
    status: {
      inprogress: 'In progress',
      ended: 'Trial ended',
      concluded: 'Concluded',
    },
    noSelection: 'No trial selected',
    emptyTrials: 'No trials exist',
    emptyTrialsDescription: 'Create a trial',
    fetchError: 'Failed fetching trial list.',
    retry: 'Retry',
    metabase: {
      title: 'Metabase dashboard',
      link: 'Open Metabase',
    },
    trialType: 'Trial type:',
    types: {
      trials: 'Trials',
      selfTrials: 'Self trials',
      selfTrial: '{name} self trial',
      plgTrials: 'PLG trials',
    },
    metadata: {
      ip: 'IP',
      country: 'IP country',
      phoneCountryCode: 'Phone country code',
      phoneNumber: 'Phone number',
      registered: 'Legally registered',
      referrer: 'Referrer',
    },
    form: {
      link: 'Trial invite link',
      endDate: 'Trial end date',
      endDateDescription: 'Access to the client side will be restricted after this date.',
      connectionRequests: 'Connection requests',
      connectionRequestsDescription: 'Select who they should be able to connect with.',
      managed: 'Managed profiles',
      managedAndSelected: 'Managed profiles & selected suppliers',
      addApprovedSupplier: 'Add approved supplier',
      cancel: 'Cancel',
      all: 'All suppliers',
      enableInvites: 'Allow client to invite suppliers',
      save: 'Save changes',
      conclude: 'Conclude trial',
      errorUpdating: 'Failed to update trial. Please try again.',
      successUpdating: 'The trial has been updated',
      errorConcluding: 'Failed to conclude trial. Please try again.',
      successConcluding: 'The trial has been concluded',
      organisation: 'Organisation',
      errorGettingOrg: 'Failed fetching organisation name.',
      noOrgAssigned: 'No organisation is assigned to this trial.',
      metadata: 'Metadata',
    },
    createdBy: 'Created by',
    createForm: {
      title: 'Create trial',
      create: 'Create trial',
      name: 'Trial name',
      namePlaceholder: 'e.g. Risk Ledger',
      nameError: 'You must give the trial a name.',
      existingOrg: 'Is this an existing organisation?',
      yes: 'Yes',
      no: 'No',
      endDate: 'End date',
      endDateDescription: 'Access to the client side will be restricted after this date.',
      endDatePlaceholder: 'DD month YYYY',
      endDateError: 'You must set an end date for the trial.',
      futureDateSelectedError: 'End date must be in the future for the trial.',
      connectionRequests: 'Connection requests',
      connectionRequestsDescription: 'Select who they should be able to connect with.',
      managed: 'Managed profiles',
      managedAndSelected: 'Managed profiles & selected suppliers',
      selectedSuppliersDisclaimer:
        'A list of preselected trial friendly suppliers will also be allowed during the trial.',
      addApprovedSupplier: 'Add approved supplier',
      all: 'All suppliers',
      enableInvites: 'Allow client to invite suppliers',
      organisation: 'Organisation',
      orgSelectPlaceholder: 'Select an organisation.',
      organisationError: 'You must select an organisation.',
      cancel: 'Cancel',
      createError: 'Failed creating trial. Please try again.',
      errorFetchingOrgs: 'An error occured. Please try again.',
      retry: 'Retry',
    },
    trialLink: {
      trialLink: 'Your trial link',
      trialLinkDescription:
        'Send the link below to your prospect, so they can sign-up for Risk Ledger and start their trial.',
      link: 'Link',
      close: 'Close',
      copy: 'Copy to clipboard',
      copied: 'Copied link to clipboard.',
      copyError: 'Failed to copy link.',
    },
  },
};
